import { render, staticRenderFns } from "./ChoosePostType.vue?vue&type=template&id=0f316894&scoped=true&"
import script from "./ChoosePostType.vue?vue&type=script&lang=ts&"
export * from "./ChoosePostType.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePostType.vue?vue&type=style&index=0&id=0f316894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f316894",
  null
  
)

export default component.exports